import { POLYGON_LOT_MAP_STATUS_AVAILABLE_HOME_SITE, POLYGON_LOT_MAP_STATUS_MODEL, POLYGON_LOT_MAP_STATUS_MOVE_IN_READY, POLYGON_LOT_MAP_STATUS_SOLD, POLYGON_LOT_MAP_STATUS_UNAVAILABLE, POLYGON_LOT_MAP_STATUS_UNDER_CONSTRUCTION } from '../util/constants';
export var LotsSortBy;
(function (LotsSortBy) {
    LotsSortBy["Price"] = "price";
    LotsSortBy["DateAdded"] = "dateAdded";
})(LotsSortBy || (LotsSortBy = {}));
export var SortDirection;
(function (SortDirection) {
    SortDirection["Ascending"] = "asc";
    SortDirection["Descending"] = "desc";
})(SortDirection || (SortDirection = {}));
// These home types might have to change depending on if the BE returns different constants
export var HomeTypes;
(function (HomeTypes) {
    HomeTypes["SingleFamily"] = "Single Family Home";
    HomeTypes["Condominium"] = "Condominium";
    HomeTypes["Flat"] = "Flat";
    HomeTypes["Town"] = "Town Home";
    HomeTypes["Paired"] = "Paired Home";
})(HomeTypes || (HomeTypes = {}));
export var LotStatuses;
(function (LotStatuses) {
    LotStatuses[LotStatuses["Sold"] = POLYGON_LOT_MAP_STATUS_SOLD] = "Sold";
    LotStatuses[LotStatuses["Model"] = POLYGON_LOT_MAP_STATUS_MODEL] = "Model";
    LotStatuses[LotStatuses["Unavailable"] = POLYGON_LOT_MAP_STATUS_UNAVAILABLE] = "Unavailable";
    LotStatuses[LotStatuses["MoveInReady"] = POLYGON_LOT_MAP_STATUS_MOVE_IN_READY] = "MoveInReady";
    LotStatuses[LotStatuses["UnderConstruction"] = POLYGON_LOT_MAP_STATUS_UNDER_CONSTRUCTION] = "UnderConstruction";
    LotStatuses[LotStatuses["Available"] = POLYGON_LOT_MAP_STATUS_AVAILABLE_HOME_SITE] = "Available";
})(LotStatuses || (LotStatuses = {}));
